import React from 'react';
import propTypes from 'prop-types';
export const CloseIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 15.125 12 L 19.820312 7.308594 C 20.394531 6.734375 20.394531 5.800781 19.820312 5.226562 L 18.773438 4.179688 C 18.199219 3.605469 17.265625 3.605469 16.691406 4.179688 L 12 8.875 L 7.308594 4.179688 C 6.734375 3.605469 5.800781 3.605469 5.226562 4.179688 L 4.179688 5.226562 C 3.605469 5.800781 3.605469 6.734375 4.179688 7.308594 L 8.875 12 L 4.179688 16.691406 C 3.605469 17.265625 3.605469 18.199219 4.179688 18.773438 L 5.226562 19.820312 C 5.800781 20.394531 6.734375 20.394531 7.308594 19.820312 L 12 15.125 L 16.691406 19.820312 C 17.265625 20.394531 18.199219 20.394531 18.773438 19.820312 L 19.820312 18.773438 C 20.394531 18.199219 20.394531 17.265625 19.820312 16.691406 Z M 15.125 12 "
        />
      </g>
    </svg>
  );
};
CloseIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};

CloseIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
